const state = {
    userinfo: {},
    menu: [],//菜单
    permissionList: [],//权限
}
const mutations = {
    setUserinfo(state, value) {
        state.userinfo = value
    },
    setMenu(state, value) {
        state.menu = value
    },
    setPermission(state, value){
        state.permissionList = value
    }
}

const actions = {
    //获取用户信息
    GetInfo({ commit }, options) {
        return new Promise((resolve, reject) => {
            console.log('获取用户信息')
            options.Userinfo().then(res => {
                commit('setUserinfo', res.data)
                commit('setMenu', res.data.role_menu.map(v => {
                    return {
                        isopen: false,
                        ...v
                    }
                }))
                commit("setPermission", res.data.role_power)
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    Loginout({ commit }, options) {
        localStorage.removeItem("token")
        commit('setUserinfo', {})
        commit("setMenu", [])
        commit("setPermission", [])
        options.router.replace('/login')
        options.resetRouter()
    }
}

export default {
    state,
    mutations,
    actions
}
